import React from 'react';
import { CheckCircleFill, PlusCircleFill } from 'react-bootstrap-icons';

export const OrderTypeContainer = ({ name, onClick, isSelected = false, id }) => {
  return (
    <div
      style={{ alignItems: 'center' }}
      onClick={() => onClick(id)}
      className={`order-type-container ${isSelected ? 'selected' : ''}`}
    >
      {isSelected ? (
        <CheckCircleFill className="align-text-top text-success" size={32} />
      ) : (
        <PlusCircleFill className="align-text-top" size={32} />
      )}
      <p className="order-type-title">{name}</p>
    </div>
  );
};
